import { PortfoliosSwitchTradesService_portfolioSwitchTradesServiceGetOverview as service } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosSwitchTradesService_portfolioSwitchTradesServiceGetOverview'

export const useFetchSwitchTrades = service.useSuspenseQuery
